import { render } from "./DesktopSteps.vue?vue&type=template&id=3b1c4cc7&scoped=true"
import script from "./DesktopSteps.vue?vue&type=script&lang=js"
export * from "./DesktopSteps.vue?vue&type=script&lang=js"

import "./DesktopSteps.vue?vue&type=style&index=0&id=3b1c4cc7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b1c4cc7"

export default script